const SURVEYS_BASE_URL = '/surveys';

export const routeCreator = {
  list: () => SURVEYS_BASE_URL,
  create: () => `${SURVEYS_BASE_URL}/create`,
  details: (id: string) => `${SURVEYS_BASE_URL}/${id}`,
  update: (id: string) => `${SURVEYS_BASE_URL}/${id}/update`,
};
